<template>
    <div>    
        <DxLoadPanel
            :visible="loadingVisible"
            :show-indicator="showIndicator"
            :show-pane="showPane"
            :shading="shading"
            :close-on-outside-click="closeOnOutsideClick"
            :on-shown="onShown"
            :on-hidden="onHidden"
            shading-color="rgba(0,0,0,0.4)"
        />
        <div class="hold-transition login-page">
        <div class="login-box" style="width: 420px;">
        <div class="login-logo">
            <img src="@/assets/logoArendal.png" alt="Arendal" />
        </div>
        <!-- /.login-logo -->
        <div class="card">
            <div class="card-body login-card-body">
            <p class="login-box-msg">Recuperar contraseña con correo registrado</p>

            <form action="#" @submit.prevent="recuperar">
                <div class="input-group mb-3">
                <input type="email" class="form-control" :disabled=disabledwait v-model="correo" placeholder="Correo">
                <div class="input-group-append">
                    <div class="input-group-text">
                    <span class="fas fa-envelope"></span>
                    </div>
                </div>
                </div>
                <div class="row">
                
                <!-- /.col -->
               <div class="col-6">
                    <router-link style="display: block;padding-left: 30px;" to="/login">Regresar</router-link>
                </div>
                <div class="col-6"> 
                    <button class="btn btn-primary btn-block" :disabled=disabledwait>Enviar</button>
                    <!-- <router-link class="btn btn-primary btn-block" to="/home">Entrar</router-link> -->
                </div>
                <!-- /.col -->
                </div>
            </form>
            
            <!-- <p class="mb-1">
                <a href="forgot-password.html">Olvidé mi contraseña</a>                
            </p> -->
             
            </div>
           
        </div>
        </div>
       
            </div>
    </div>
</template>

<script>


export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_API;

import notify from 'devextreme/ui/notify';
import { DxLoadPanel } from 'devextreme-vue/load-panel';





export default {
    components: {
        DxLoadPanel
    },
    data() {
        return {
            loadingVisible: false,//Configuracion de loader
            showIndicator: true,
            shading: true,
            showPane: true,
            closeOnOutsideClick: false,

            correo: '',
            disabledwait:false,
            timeoutVar:null
        }
    },
    name: 'Recuperar',
    methods: {
        recuperar() {
            var that = this;
            that.loadingVisible = true;
            if (that.correo) {
                let email = that.correo
                that.$store.dispatch('recuperar', {
                        email
                    })
                    .then((response) => {
                        console.log(response);
                        if (response.data[0].Estatus == 'OK') {
                            //! Aqui se enviará el correo                   
                            //that.$router.push('/home')
                            //that.$cookies.remove("TiempoEspera");
                            notify(response.data[0].Mensaje, 'success');
                            that.$router.push({name:'Home'});
                        } else {
                            //! Aqui se marca error que no existe el correo
                            notify(response.data[0].Mensaje, 'error');
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
                that.loadingVisible = false;
            } else {
                notify('Es necesario ingresar correo', 'error')
                that.loadingVisible = false;
            }
        },
        onShown() {
            console.log('Mostrando loader...');
        },
        onHidden() {
            console.log('Cerrando loader...');
        },
        
        enabledAll:function(){
            console.log('reestableciendo');
            this.disabledwait=false;
        }
    },
    watch: {
        timeoutVar(val){
            console.log(val);
        }
    }
}
</script>